import React, { useState, useRef, useEffect } from 'react';
import { animate } from 'animejs';
import { useLanguage } from '../context/LanguageContext';
import './FAQ.css';

function FAQ() {
  const { t } = useLanguage();
  const [openId, setOpenId] = useState(null);
  const sectionRef = useRef(null);
  const items = t('faq.items');

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        const cards = section.querySelectorAll('.faq-item');
        cards.forEach((el, i) => {
          animate(el, {
            opacity: [0, 1],
            y: [20, 0],
            duration: 500,
            delay: i * 80,
            ease: 'outExpo',
          });
        });
        observer.disconnect();
      },
      { rootMargin: '0px 0px -60px 0px', threshold: 0.1 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={sectionRef} className="faq" id="faq">
      <h2 id="faq-title" className="section-title">{t('faq.title')}</h2>
      <div className="faq-list">
        {items.map((item, i) => (
          <div
            key={i}
            className={`faq-item ${openId === i ? 'is-open' : ''}`}
          >
            <button
              type="button"
              className="faq-question"
              onClick={() => setOpenId(openId === i ? null : i)}
              aria-expanded={openId === i}
              aria-controls={`faq-answer-${i}`}
              id={`faq-question-${i}`}
            >
              <span>{item.q}</span>
              <span className="faq-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
                  <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
            </button>
            <div
              id={`faq-answer-${i}`}
              className="faq-answer"
              role="region"
              aria-labelledby={`faq-question-${i}`}
            >
              <p>{item.a}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQ;
